export const localPalindromeApi =
  'http://localhost:9000/2015-03-31/functions/function/invocations';
export const prodPalindromeApi =
  'https://i99lgz5h8f.execute-api.us-west-2.amazonaws.com/api/is-palindrome';
export const prodOpenAIAPI =
  'https://u11qv3b7q8.execute-api.us-west-2.amazonaws.com/ai-api/hire-nate';
